var _path, _g, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderWithPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17155_166727",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66602 1.66675H18.9132V18.8908H1.66602V1.66675Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17155_166727)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36852 2.91675C3.94852 2.91675 2.91602 4.14675 2.91602 7.02758V13.5267C2.91602 16.1801 4.38102 17.6409 7.04102 17.6409H13.526C16.1793 17.6409 17.6402 16.1801 17.6402 13.5267V13.5242L17.6635 9.38675C17.6635 6.55425 16.6918 5.45008 14.196 5.45008H11.8377C11.0468 5.44925 10.2918 5.07175 9.81685 4.44008L9.05602 3.42841C8.81685 3.10758 8.43435 2.91758 8.03435 2.91675H6.36852ZM13.526 18.8909H7.04102C3.72602 18.8909 1.66602 16.8351 1.66602 13.5267V7.02758C1.66602 3.47008 3.24852 1.66675 6.36852 1.66675H8.03518C8.82768 1.66758 9.58268 2.04591 10.056 2.67841L10.8152 3.68841C11.056 4.00841 11.4385 4.19925 11.8385 4.20008H14.196C17.4143 4.20008 18.9135 5.84925 18.9135 9.39008L18.8902 13.5292C18.8894 16.8359 16.8343 18.8909 13.526 18.8909Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9296 12.2607H6.65039C6.30539 12.2607 6.02539 11.9807 6.02539 11.6357C6.02539 11.2907 6.30539 11.0107 6.65039 11.0107H13.9296C14.2746 11.0107 14.5546 11.2907 14.5546 11.6357C14.5546 11.9807 14.2746 12.2607 13.9296 12.2607Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66406 15.2755L9.66406 7.99634C9.66406 7.65134 9.94406 7.37134 10.2891 7.37134C10.6341 7.37134 10.9141 7.65134 10.9141 7.99634L10.9141 15.2755C10.9141 15.6205 10.6341 15.9005 10.2891 15.9005C9.94406 15.9005 9.66406 15.6205 9.66406 15.2755Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderWithPlus);
export default __webpack_public_path__ + "static/media/folder-with-plus.06d0e865e31604f7b5cd3d3b05c95f75.svg";
export { ForwardRef as ReactComponent };